import React from "react";
import { Button, Box, ButtonGroup } from "@mui/material";

const SegmentButton2 = ({ buttonsConfig, activeButton, setActiveButton }) => {
  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        borderRadius: "25px",
        overflowX: "auto", // Enable horizontal scrolling
        whiteSpace: "nowrap", // Prevent buttons from wrapping
      }}
    >
      <ButtonGroup size="medium" aria-label="Segmented button group">
        {buttonsConfig.map((buttonConfig, index) => (
          <Button
            key={buttonConfig.key}
            onClick={() => handleButtonClick(buttonConfig.key)}
            sx={{
              backgroundColor:
                activeButton === buttonConfig.key ? "#250258" : "white",
              color: activeButton === buttonConfig.key ? "#FFFFFF" : "#444444",
              fontFamily: "Urbane-Light",
              fontWeight: activeButton === buttonConfig.key ? "500" : "500",
              fontSize: "12px",
              lineHeight: "28px",
              border: "0.5px solid #00000029",
              textTransform: "capitalize",
              borderRadius:
                index === 0
                  ? "25px 0 0 25px" // Apply rounded corners to the first button
                  : index === buttonsConfig.length - 1
                  ? "0 25px 25px 0" // Apply rounded corners to the last button
                  : "0", // No border radius for middle buttons
              "&:hover": {
                backgroundColor:
                  activeButton === buttonConfig.key ? "#1F0145" : "#E0E0E0",
                border: "0.5px solid #00000029",
              },
            }}
          >
            {buttonConfig.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default SegmentButton2;
